// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__1McdH","name":"style_name__Vdkca","chip":"style_chip__2pKD3","heading":"style_heading__1ojwa","loadMore":"style_loadMore__1QByV"};